import cx from 'classnames'

type SlidingPanelProps = {
  children?: React.ReactNode
  className?: string
  hide?: boolean
}

const SlidingPanel = ({ children, className, hide }: SlidingPanelProps) => {
  return (
    <div
      className={cx(
        'flex flex-shrink-0 transform duration-300 transition-transform',
        {
          [`-translate-x-full`]: hide,
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default SlidingPanel
